/* Signature — product image zoom. Opens the full-resolution image in a
   dialog; click/tap toggles a 2x magnified view that follows the pointer.
   When the product has more media, the lightbox becomes a gallery: arrow
   buttons, arrow keys, and a counter navigate every image without leaving
   the dialog. */
(function () {
  'use strict';

  const dialog = document.getElementById('zoom-dialog');
  if (!dialog) return;
  const stage = dialog.querySelector('[data-zoom-stage]');

  let mediaList = [];
  let mediaIndex = 0;

  function widen(src) {
    return (src || '').replace(/([?&])width=\d+/, '$1width=1800');
  }

  function collectMedia() {
    const templates = document.querySelectorAll('[data-media-templates] template');
    return Array.from(templates)
      .map((template) => {
        const img = template.content
          ? template.content.querySelector('img')
          : template.querySelector('img');
        if (!img) return null;
        return {
          id: template.getAttribute('data-template-media-id'),
          src: widen(img.getAttribute('src') || img.src),
          alt: img.getAttribute('alt') || '',
        };
      })
      .filter(Boolean);
  }

  function currentImg() {
    return stage.querySelector('.zoom__img');
  }

  function updateCounter() {
    const counter = dialog.querySelector('[data-zoom-counter]');
    if (counter) {
      counter.textContent = (mediaIndex + 1) + ' / ' + mediaList.length;
    }
  }

  function step(delta) {
    if (mediaList.length < 2) return;
    mediaIndex = (mediaIndex + delta + mediaList.length) % mediaList.length;
    const item = mediaList[mediaIndex];
    const img = currentImg();
    if (!img || !item) return;
    img.classList.remove('is-zoomed');
    img.style.transformOrigin = 'center center';
    const control = img.closest('[data-zoomable]');
    if (control) control.setAttribute('aria-pressed', 'false');
    img.src = item.src;
    img.alt = item.alt;
    updateCounter();
  }

  function buildNav() {
    dialog.querySelectorAll('.zoom__nav, .zoom__counter').forEach((el) => el.remove());
    if (mediaList.length < 2) return;

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'zoom__nav zoom__nav--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.textContent = '‹';
    prev.addEventListener('click', (e) => { e.stopPropagation(); step(-1); });

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'zoom__nav zoom__nav--next';
    next.setAttribute('aria-label', 'Next image');
    next.textContent = '›';
    next.addEventListener('click', (e) => { e.stopPropagation(); step(1); });

    const counter = document.createElement('span');
    counter.className = 'zoom__counter';
    counter.setAttribute('data-zoom-counter', '');
    counter.setAttribute('aria-live', 'polite');

    stage.append(prev, next, counter);
    updateCounter();
  }

  function open(src, alt, trigger) {
    const control = document.createElement('button');
    control.type = 'button';
    control.className = 'zoom__control';
    control.setAttribute('data-zoomable', '');
    control.setAttribute('aria-pressed', 'false');
    control.setAttribute('aria-label', trigger.getAttribute('aria-label') || 'Toggle image magnification');
    const img = document.createElement('img');
    img.src = src;
    img.alt = alt || '';
    img.className = 'zoom__img';
    control.appendChild(img);
    stage.replaceChildren(control);
    buildNav();
    window.sigOpenDialog(dialog, trigger);
  }

  function openFromTrigger(trigger) {
    const img = trigger.querySelector('img');
    if (!img) return;
    mediaList = collectMedia();
    const main = trigger.closest('[data-main-media]');
    const currentId = main && main.getAttribute('data-current-media-id');
    mediaIndex = Math.max(0, mediaList.findIndex((m) => m.id === currentId));
    const src = widen(img.currentSrc || img.src);
    open(src, img.alt, trigger);
  }

  function toggleZoom(control) {
    const img = control.querySelector('.zoom__img');
    if (!img) return;
    img.classList.toggle('is-zoomed');
    control.setAttribute('aria-pressed', String(img.classList.contains('is-zoomed')));
    if (!img.classList.contains('is-zoomed')) {
      img.style.transformOrigin = 'center center';
    }
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-zoom-trigger]');
    if (trigger) {
      e.preventDefault();
      openFromTrigger(trigger);
      return;
    }

    const zoomable = e.target.closest('[data-zoomable]');
    if (zoomable) {
      toggleZoom(zoomable);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (dialog.open) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); return; }
    }
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const trigger = e.target.closest('[data-zoom-trigger]');
    if (trigger) {
      e.preventDefault();
      openFromTrigger(trigger);
    }
  });

  stage.addEventListener('pointermove', (e) => {
    const img = stage.querySelector('.is-zoomed');
    if (!img) return;
    const rect = img.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = x + '% ' + y + '%';
  });

  dialog.addEventListener('close', () => stage.replaceChildren());
})();
